import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import propertyMachineryListAction from './propertyMachineryList.action.json' with { type: 'json' }
import { propertyMachineryObject } from '../propertyMachineryObject'

export const propertyMachineryExpression = expression(propertyMachineryObject.shape)

const propertyMachineryListDefinition = defineAction({
  ...propertyMachineryListAction,

  input: z.object({
    filter: propertyMachineryExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      machineryType: 'Tipo de máquina',
      quantity: 'Quantidade',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(propertyMachineryObject),
    count: z.number(),
  }),
})

export default propertyMachineryListDefinition
